<template>
      <v-card>
        <v-card-title> {{ $t('lottery_thai.head_limit') }} </v-card-title>
        <v-card-actions>
          <v-row no-gutters class="d-flex align-center justify-end">
            <v-spacer />
            <v-btn v-if="canCreate" color="primary" @click="linkToAdd" style="margin-top: 1px">{{ $t('lottery_thai.create')
            }}</v-btn>
          </v-row>
        </v-card-actions>
        <v-card-actions class="pt-0">
          <v-data-table mobile-breakpoint="0" style="width: 100%" :headers="headers" :items="valueLimit"
            :no-data-text="$t('not_found')" :no-results-text="$t('not_found')" :options.sync="pagination"
            :server-items-length="pagination.totalItems" :items-per-page="pagination.rowsPerPage"
            :page.sync="pagination.page" :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }" :loading="loading" :search="search">
          </v-data-table>
        </v-card-actions>
      </v-card>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import store from '@/store'
export default {
  props: {
    canCreate: {
      type: Boolean,
      require: true
    },
    roundDateNow: {
      type: String,
      require: true
    },
    dateFrom: {
      type: String,
      require: true
    },
    dateTo: {
      type: String,
      require: true
    },
  },
  data() {
    return {
      search: '',
      loading: false,
      headers: [
        {
          text: this.$t('lottery_thai.header_limit1'),
          value: 'id',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
         text: this.$t('lottery_thai.header_limit2'),
         value: 'roundDate',
         width: '100px',
         align: 'center',
         sortable: false,
        },
        {
          text: this.$t('lottery_thai.header_limit3'),
          value: 'lotteryNumber',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('lottery_thai.header_limit4'),
          value: 'quantityLimit',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('lottery_thai.header_limit5'),
          value: 'remaining',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('lottery_thai.header_limit6'),
          value: 'username',
          width: '100px',
          align: 'center',
          sortable: false,
        },
      ],
      valueLimit: [],
      pagination: {
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
      },
    }
  },
  async created() {
  },
  watch: {
    dateFrom: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (this.tab === 1 && newVal !== oldVal) {
          if(oldVal){
            this.loading = true
            this.pagination.page = 1
            await this.loadLimitData()
            this.loading = false
          }
        }
      }
    },
    dateTo: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (this.tab === 1 && newVal !== oldVal) {
          if(oldVal){
            this.loading = true
            this.pagination.page = 1
            await this.loadLimitData()
            this.loading = false
          }
        }
      }
    },
    pagination: {
      async handler(newValue, oldValue) {
        let cont = false
        if (oldValue.page !== newValue.page) cont = true
        if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
        if (oldValue.sortBy !== newValue.sortBy) cont = true
        if (oldValue.sortDesc !== newValue.sortDesc) cont = true
        if (cont && this.tab === 1) {
          this.loading = true
          this.valueLimit = []
          await this.getLotteryThaiLimitData(newValue.page, newValue.itemsPerPage)
          this.loading = false
        }
      },
      deep: true,
    },
  },
  methods: {
    async loadLimitData() {
        this.valueLimit = []
        await this.getLotteryThaiLimitData(this.pagination.page, this.pagination.rowsPerPage)
    },
    async getLotteryThaiLimitData(page, row, search) {
      this.valueLimit = []
      try {
        let result = await this.$store.dispatch('lotteryThai/getLotteryLimitList', `page=${page}&rows=${row}&from=${this.formatDateYYYY(this.dateFrom)}&to=${this.formatDateYYYY(this.dateTo)}${this.search || ''}`)
        let resData = result.data
        for (let i = 0; i < resData.length; i++) {
          let disabledResult = true

          function isEmptyValues(...values) {
            for (const value of values) {
              if (value === null || value === '') {
                return true
              }
            }
            return false
          }

          this.valueLimit.push({
            id: resData[i].id || null,
            roundDate: resData[i].roundDate || null,
            username: resData[i].admin.username || null,
            lotteryNumber: resData[i].lotteryNumber || null,
            quantityLimit: resData[i].quantityLimit || 0,
            remaining: resData[i].remaining || 0,
            disabledResult: disabledResult,
          })
        }

        this.pagination.totalItems = result.count
      } catch (e) { }
    },
    linkToAdd() {
      this.$router.push({ name: 'lottery-thai-add-limit' ,query: { roundDateSelect: this.roundDateNow }})
    },
    formatDateYYYY(date) {
      const dateConv = date?.length > 8 ? date.substring(2) : date
      return moment(`20${dateConv}`).format('YYYY-MM-DD')
    },
  },
  computed: {
    tab: {
        get() {
        return this.$store.state.lotteryThai.tab;
        },
        set(val) {
        this.$store.commit('lotteryThai/setActiveTab', val);
        }
    },
  },
}
</script>